import './imgPop';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// /tareas (gestor de tareas personal, solo admin) va sin el diseño de la web y en su propio
// trozo de JS, para que la web publica no cargue con el.
const Tareas = React.lazy(() => import('./views/tareas'));

ReactDOM.render(
  window.location.pathname.startsWith('/tareas')
    ? <React.Suspense fallback={null}><Tareas /></React.Suspense>
    : <App />,
  document.getElementById('root')
);




// Cloudflare Web Analytics — solo en produccion, para no contaminar
// las metricas con las visitas de desarrollo (localhost).
if (process.env.NODE_ENV === 'production') {
  const beacon = document.createElement('script');
  beacon.type = 'module';
  beacon.defer = true;
  beacon.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  beacon.setAttribute(
    'data-cf-beacon',
    '{"token": "a19425f804f2458dae6d87f027697411"}'
  );
  document.body.appendChild(beacon);
}

// El service worker de la web es public/sw.js (notificaciones push) y lo registra
// Ajustes > Notificaciones; /tareas registra el suyo (public/sw-tareas.js, solo para /tareas).
// Aqui no se desregistra nada: se llevaria esos por delante.
